import { useTheme } from '@mui/material';

export const NoRatingSvg = () => {
	const { palette } = useTheme();

	return (
		<svg width="113" height="72" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M39.5 17.2c4 1 11.9 2.5 15.3 3.2 18 4 19.5 13.6 25 27.3C85 61.5 74 66.7 64 66.1c-10-.5-30.5-8.2-35.5-15-5-7-12-14.5-11.5-27.2.5-12.8 17.5-8 22.5-6.7Z"
				fill="#F2F2F2"
				fillOpacity=".8"
			/>
			<path
				d="M36.6 15.3c2 5.6 2 12.5 1.6 15.3-2 34.3 20.4 35.9 31.6 34C81 62.5 88.4 42 90.6 39.1c2.1-2.9 5.3-14.1 5.7-22.1.4-8-9-5.2-16.7-3.4C71.9 15.5 61 8 52.7 3.7 44.5-.6 42-.3 38.2.3c-3.7.5-4.1 8-1.6 15Z"
				fill="#EBEDF6"
				fillOpacity=".8"
			/>
			<path
				d="M1 70.5h111"
				stroke={palette.primary.main}
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M59.5 24c.2-.4.8-.4 1 0L64 35c.2.6.8 1 1.4 1H77c.5 0 .7.6.3 1l-9.3 6.6c-.5.4-.7 1.1-.5 1.7l3.5 11c.2.4-.4.8-.8.5L61 50c-.5-.3-1.3-.3-1.8 0L50 56.8c-.4.3-1-.1-.8-.6l3.5-10.9c.2-.6 0-1.3-.5-1.7L42.8 37a.5.5 0 0 1 .3-.9h11.5c.6 0 1.2-.4 1.4-1l3.5-11Z"
				fill={palette.primary.light}
				stroke={palette.primary.main}
			/>
			<path
				d="M79.5 17.5c.2-.5.8-.5 1 0l1.4 4.4c0 .2.3.3.5.3H87c.5 0 .7.6.3 1l-3.7 2.6c-.2.2-.3.4-.2.6l1.4 4.4c.2.5-.4.9-.8.6l-3.7-2.7a.5.5 0 0 0-.6 0L76 31.4c-.4.3-1-.1-.8-.6l1.4-4.4c0-.2 0-.4-.2-.6l-3.7-2.7a.5.5 0 0 1 .3-.9h4.6c.2 0 .4-.1.5-.3l1.4-4.4ZM32.5 43.5c.2-.5.8-.5 1 0l1.9 5.8c0 .2.2.3.4.3H42c.5 0 .7.6.3 1l-5 3.5c0 .1-.2.3 0 .5l1.8 5.8c.1.5-.4.9-.8.6l-5-3.6a.5.5 0 0 0-.5 0l-5 3.6c-.3.3-.8-.1-.7-.6l1.9-5.8c0-.2 0-.4-.2-.5l-5-3.6a.5.5 0 0 1 .4-.9h6c.3 0 .5-.1.5-.3l2-5.8Z"
				fill={palette.primary.light}
			/>
		</svg>
	);
};
